import React, { useState, useEffect } from "react";
import "../../ViewInfo.css";
import { TextField, Button, MenuItem } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import SEFChangePage from "../../../components/ChangePage/SEFChangePage";
import { Consultant_Get_One_Nested_Prop_From_MongoDB } from "../../../../Consultants/api/Consultant_Get_One_Nested_Prop_From_MongoDB";
import { ConsultantuseAuth } from "../../../../Consultants/security/ConsultantUseAuth";
import { Consultant_Update_To_MongoDB_By_ID } from "../../../../Consultants/api/Consultant_Update_To_MongoDB_By_ID";
import { Get_One_Choose_Fields_From_MongoDB } from "../../../../Consultants/api/Get_One_Choose_Fields_From_MongoDB";
import { Arr_SummerArrivalDeparture } from "../../../../arrays/SEF/Arr_SummerArrivalDeparture";
import getArrayOfQuestionsAndNeededToSubmit from "../../../components/Questions/GetUsefulArrays/getArrayOfQuestionsAndNeededToSubmit";
import DisplayTextField from "../../../components/Questions/DisplayTextField";

function ArrivalDeparture() {
  const { id } = useParams();

  let logoutStudent;
  let logoutConsultant;
  if (window.location.href.indexOf("Student") > -1) {
    logoutStudent = StudentuseAuth().logoutStudent;
  } else {
    logoutConsultant = ConsultantuseAuth().logoutConsultant;
  }

  const [formInfo, setformInfo] = useState({ Progress: "" });

  //-------------------------------------------Start Get Airport Vairent

  //Get Order Info and BasicInfo to check airport status
  const [BasicInfo, setBasicInfo] = useState({});
  const [OrderInfo, setOrderInfo] = useState({});

  let AirportCombination = "Loading...";
  if (
    OrderInfo.ProgrammeAirportArrival === "Yes" &&
    OrderInfo.ProgrammeAirportDeparture !== "Yes"
  ) {
    AirportCombination = "Airport_Arrival_Only";
  } else if (
    OrderInfo.ProgrammeAirportArrival !== "Yes" &&
    OrderInfo.ProgrammeAirportDeparture === "Yes"
  ) {
    AirportCombination = "Airport_Departure_Only";
  } else if (
    (OrderInfo.ProgrammeAirportArrival === "Yes" &&
      OrderInfo.ProgrammeAirportDeparture === "Yes") ||
    BasicInfo.ProgrammeVarient?.toLowerCase().indexOf("airport") > -1
  ) {
    AirportCombination = "Airport_Arrival_and_Departure";
  } else {
    AirportCombination = "No_Airport_Transfers";
  }

  //Filter questions array
  let Arr_SummerArrivalDeparture_Filtered = Arr_SummerArrivalDeparture;
  if (AirportCombination === "Airport_Arrival_Only") {
    Arr_SummerArrivalDeparture_Filtered =
      Arr_SummerArrivalDeparture_Filtered.filter(
        (item) =>
          item.AiportType === "Arrival_Airport" ||
          item.AiportType === "Departure_General"
      );
  } else if (AirportCombination === "Airport_Departure_Only") {
    Arr_SummerArrivalDeparture_Filtered =
      Arr_SummerArrivalDeparture_Filtered.filter(
        (item) =>
          item.AiportType === "Arrival_General" ||
          item.AiportType === "Departure_Airport"
      );
  } else if (AirportCombination === "Airport_Arrival_and_Departure") {
    Arr_SummerArrivalDeparture_Filtered =
      Arr_SummerArrivalDeparture_Filtered.filter(
        (item) =>
          item.AiportType === "Departure_Airport" ||
          item.AiportType === "Arrival_Airport"
      );
  } else if (AirportCombination === "No_Airport_Transfers") {
    Arr_SummerArrivalDeparture_Filtered =
      Arr_SummerArrivalDeparture_Filtered.filter(
        (item) =>
          item.AiportType === "Arrival_General" ||
          item.AiportType === "Departure_General"
      );
  }

  //-------------------------------------------End Get Airport Vairent

  //Get all questions for this page
  const { arrayOfQuestions, neededToSubmit } =
    getArrayOfQuestionsAndNeededToSubmit(
      "SummerArrivalDeparture",
      formInfo,
      Arr_SummerArrivalDeparture_Filtered
    );

  const [obj_EC, setobj_EC] = useState({});
  const [obj_assignedEC, setobj_assignedEC] = useState({});
  const [StudentData, setStudentData] = useState({});

  //Get student data
  useEffect(() => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "SummerArrivalDeparture",
        setformInfo,
        logoutStudent
      );
      //
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "BasicInfo",
        setBasicInfo,
        logoutStudent
      );
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "OrderInfo",
        setOrderInfo,
        logoutStudent
      );
    } else {
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "SummerArrivalDeparture",
        setformInfo,
        logoutConsultant
      );
      Get_One_Choose_Fields_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        { IPInfo: 1, SummerArrivalDeparture: 1, OrderInfo: 1 },
        setStudentData,
        logoutConsultant
      );
      //
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "BasicInfo",
        setBasicInfo,
        logoutConsultant
      );
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "OrderInfo",
        setOrderInfo,
        logoutConsultant
      );
    }
  }, []);

  //Get IP Data if consultant is logged in
  useEffect(() => {
    //if the web page URL contains the string Student
    if (window.location.href.indexOf("Student") > -1) {
    } else {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        {},
        setobj_EC,
        logoutConsultant
      );
      if (StudentData && StudentData._id && StudentData._id.length === 24) {
        Get_One_Choose_Fields_From_MongoDB(
          "IP",
          "EC",
          StudentData.IPInfo?.EC_ID,
          { _id: 1, "MetaData.Agency_id": 1 },
          setobj_assignedEC,
          logoutConsultant
        );
      }
    }
  }, [StudentData]);

  let EC_Check_Permissions = false;
  if (
    localStorage.getItem("Consultant_id") === StudentData.IPInfo?.EC_ID ||
    (obj_EC.MetaData?.Admin === "Yes" &&
      obj_EC.MetaData?.Agency_id === obj_assignedEC.MetaData?.Agency_id)
  ) {
    EC_Check_Permissions = true;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    let data = { ...formInfo };
    data.Progress = "In_Progress";

    //if AirportCombination===Airport_Arrival_Only or Airport_Arrival_and_Departure, find any props in data that start with "Arrival_General" and make them eqaul to "".
    //  if AirportCombination===Airport_Departure_Only or No_Airport_Transfers, find any props in data that start with "Arrival_Airport" and make them eqaul to "".
    //  if AirportCombination===Airport_Departure_Only or Airport_Arrival_and_Departure, find any props in data that start with "Departure_General" and make them eqaul to "".
    //  if AirportCombination===Airport_Arrival_Only or No_Airport_Transfers, find any props in data that start with "Departure_Airport"and make them eqaul to "".
    console.log("Before");
    console.log(data);
    if (
      AirportCombination === "Airport_Arrival_Only" ||
      AirportCombination === "Airport_Arrival_and_Departure"
    ) {
      console.log("1111");
      Object.keys(data).forEach((key) => {
        if (key.startsWith("Arrival_General")) {
          data[key] = "";
        }
      });
    }
    if (
      AirportCombination === "Airport_Departure_Only" ||
      AirportCombination === "No_Airport_Transfers"
    ) {
      console.log("2222");

      Object.keys(data).forEach((key) => {
        if (key.startsWith("Arrival_Airport")) {
          data[key] = "";
        }
      });
    }
    if (
      AirportCombination === "Airport_Departure_Only" ||
      AirportCombination === "Airport_Arrival_and_Departure"
    ) {
      console.log("3333");

      Object.keys(data).forEach((key) => {
        if (key.startsWith("Departure_General")) {
          data[key] = "";
        }
      });
    }
    if (
      AirportCombination === "Airport_Arrival_Only" ||
      AirportCombination === "No_Airport_Transfers"
    ) {
      console.log("4444");

      Object.keys(data).forEach((key) => {
        if (key.startsWith("Departure_Airport")) {
          data[key] = "";
        }
      });
    }

    console.log("After");
    console.log(data);

    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          SummerArrivalDeparture: data,
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "Your progress has been saved, you may now close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          SummerArrivalDeparture: data,
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setPageButtonStatus(true);
    setformInfo(data);
  };

  const handleSubmit = () => {
    let data = { ...formInfo };
    data.Progress = "Awaiting_Review";

    //if AirportCombination===Airport_Arrival_Only or Airport_Arrival_and_Departure, find any props in data that start with "Arrival_General" and make them eqaul to "".
    //  if AirportCombination===Airport_Departure_Only or No_Airport_Transfers, find any props in data that start with "Arrival_Airport" and make them eqaul to "".
    //  if AirportCombination===Airport_Departure_Only or Airport_Arrival_and_Departure, find any props in data that start with "Departure_General" and make them eqaul to "".
    //  if AirportCombination===Airport_Arrival_Only or No_Airport_Transfers, find any props in data that start with "Departure_Airport"and make them eqaul to "".

    if (
      AirportCombination === "Airport_Arrival_Only" ||
      AirportCombination === "Airport_Arrival_and_Departure"
    ) {
      Object.keys(data).forEach((key) => {
        if (key.startsWith("Arrival_General")) {
          data[key] = "";
        }
      });
    }
    if (
      AirportCombination === "Airport_Departure_Only" ||
      AirportCombination === "No_Airport_Transfers"
    ) {
      Object.keys(data).forEach((key) => {
        if (key.startsWith("Arrival_Airport")) {
          data[key] = "";
        }
      });
    }
    if (
      AirportCombination === "Airport_Departure_Only" ||
      AirportCombination === "Airport_Arrival_and_Departure"
    ) {
      Object.keys(data).forEach((key) => {
        if (key.startsWith("Departure_General")) {
          data[key] = "";
        }
      });
    }
    if (
      AirportCombination === "Airport_Arrival_Only" ||
      AirportCombination === "No_Airport_Transfers"
    ) {
      Object.keys(data).forEach((key) => {
        if (key.startsWith("Departure_Airport")) {
          data[key] = "";
        }
      });
    }

    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          SummerArrivalDeparture: data,
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "This page has been submitted, you may now close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          SummerArrivalDeparture: data,
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setPageButtonStatus(true);
    setformInfo(data);
  };

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  //---------------------------------------Start Dated

  //Get Length
  let str_Length;
  if (BasicInfo.ProgrammeVarient?.toLowerCase().includes("1 week")) {
    str_Length = "1 Week";
  } else if (BasicInfo.ProgrammeVarient?.toLowerCase().includes("premium")) {
    str_Length = "2 Weeks";
  } else if (
    BasicInfo.ProgrammeVarient?.toLowerCase().includes("2 week") ||
    BasicInfo.ProgrammeVarient?.toLowerCase().includes("2 - week") ||
    BasicInfo.ProgrammeVarient?.toLowerCase().includes("2-week")
  ) {
    str_Length = "2 Weeks";
  } else {
    str_Length = "TBC";
  }

  //Get Dates
  let str_StartDate;
  let str_EndDate;
  let str_AccomStartDate;
  let str_AccomEndDate;

  if (BasicInfo.ProgrammeDate?.toLowerCase().includes("18th aug")) {
    str_StartDate = "18th August 2025";
  } else if (BasicInfo.ProgrammeDate?.toLowerCase().includes("28th july")) {
    str_StartDate = "28th July 2025";
  } else if (BasicInfo.ProgrammeDate?.toLowerCase().includes("7th july")) {
    str_StartDate = "7th July 2025";
  } else {
    str_StartDate = "TBC";
  }

  //make str_AccomStartDate = str_StartDate - 1
  if (str_StartDate === "18th August 2025") {
    str_AccomStartDate = "17th August 2025";
  } else if (str_StartDate === "28th July 2025") {
    str_AccomStartDate = "27th July 2025";
  } else if (str_StartDate === "7th July 2025") {
    str_AccomStartDate = "6th July 2025";
  } else {
    str_AccomStartDate = "TBC";
  }

  //get str_EndDate as str_StartDate + str_Length
  if (str_StartDate === "18th August 2025") {
    //
    if (str_Length === "1 Week") {
      str_EndDate = "22nd August 2025";
    } else if (str_Length === "2 Weeks") {
      str_EndDate = "29th August 2025";
    } else {
      str_EndDate = "TBC";
    }

    //
  } else if (str_StartDate === "28th July 2025") {
    //
    if (str_Length === "1 Week") {
      str_EndDate = "1st August 2025";
    } else if (str_Length === "2 Weeks") {
      str_EndDate = "8th August 2025";
    } else {
      str_EndDate = "TBC";
    }
    //
  } else if (str_StartDate === "7th July 2025") {
    //
    if (str_Length === "1 Week") {
      str_EndDate = "11th July 2025";
    } else if (str_Length === "2 Weeks") {
      str_EndDate = "18th July 2025";
    } else {
      str_EndDate = "TBC";
    }
    //
  } else {
    str_EndDate = "TBC";
  }

  //make str_AccomEndDate = str_EndDate + 1
  if (str_EndDate === "22nd August 2025") {
    str_AccomEndDate = "23rd August 2025";
  } else if (str_EndDate === "29th August 2025") {
    str_AccomEndDate = "30th August 2025";
  } else if (str_EndDate === "1st August 2025") {
    str_AccomEndDate = "2nd August 2025";
  } else if (str_EndDate === "8th August 2025") {
    str_AccomEndDate = "9th August 2025";
  } else if (str_EndDate === "11th July 2025") {
    str_AccomEndDate = "12th July 2025";
  } else if (str_EndDate === "18th July 2025") {
    str_AccomEndDate = "19th July 2025";
  } else {
    str_AccomEndDate = "TBC";
  }
  //-------------------------------------End Dates

  //---Get dates for date questioons

  let DateQuestions = [
    {
      Type: "Arrival_Airport",
      Start: 0,
      Length: 7,
      Label: "Airport Arrival/ Landing Date",
      Name: "Arrival_Airport_Date",
      Options: [str_AccomStartDate],
      Title: "Airport Transfer Arrival Information",
    },
    {
      Type: "Arrival_General",
      Start: 7,
      Length: 10,
      Label: "Arrival Date",
      Name: "Arrival_General_Date",
      Options: [str_AccomStartDate, str_StartDate],
      Title: "Accomodation Arrival Information",
    },
    {
      Type: "Departure_Airport",
      Start: 17,
      Length: 7,
      Label: "Airport Departure/ Take-Off Date",
      Name: "Departure_Airport_Date",
      Options: [str_AccomEndDate],
      Title: "Airport Transfer Departure Information",
    },
    {
      Type: "Departure_General",
      Start: 24,
      Length: 9,
      Label: "Departure Date",
      Name: "Departure_General_Date",
      Options: [str_AccomEndDate, str_EndDate],
      Title: "Accomodation Departure Information",
    },
  ];
  //end get dates for Date Questions

  //Get formcompelte check
  let DateQuestionsCompleteCheck = DateQuestions.filter((question) => {
    return (AirportCombination === "Airport_Arrival_Only" &&
      (question.Type === "Arrival_Airport" ||
        question.Type === "Departure_General")) ||
      (AirportCombination === "Airport_Departure_Only" &&
        (question.Type === "Arrival_General" ||
          question.Type === "Departure_Airport")) ||
      (AirportCombination === "Airport_Arrival_and_Departure" &&
        (question.Type === "Departure_Airport" ||
          question.Type === "Arrival_Airport")) ||
      (AirportCombination === "No_Airport_Transfers" &&
        (question.Type === "Arrival_General" ||
          question.Type === "Departure_General"))
      ? true
      : false;
  });

  const isFormComplete =
    neededToSubmit.length === 0 &&
    DateQuestionsCompleteCheck.map((question) => {
      return (
        formInfo[question.Name] !== "" && formInfo[question.Name] !== undefined
      );
    }).every((value) => value === true);

  //End get form complete check

  //Visuals for custom Q

  const inputProps = {
    style: {
      backgroundColor: "white",
      textAlign: "left",
      color: "black", // Set the font color to black
    },
  };

  const inputLabelProps = {
    style: {
      fontSize: "1.2rem", // Increase the font size of the label
      color: "black", // Set the label color to black
    },
    shrink: true,
  };
  //end visuals for custom Q

  //Get intro Text
  let str_intoText = <p>...</p>;

  if (AirportCombination === "No_Airport_Transfers") {
    str_intoText = (
      <p style={{ fontSize: "1.3em" }}>
        Residential students should arrive at the accommodation between 12pm and
        5pm on check-in day ({str_AccomStartDate}). We will run an informal
        activity programme during this time. There will be a formal induction
        session at 6pm.
        <br></br>
        Alternatively students can arrive at the accomodation between 8am and
        10am on the first day of the programme ({str_StartDate}).
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        On the students' final day in the accommodation ({str_AccomEndDate}),
        they will need to check out of their rooms by 10am. They should leave by
        1pm.
        <br></br>
        Alternatively students can depart the evening of their final programme
        day ({str_EndDate}) 5pm and 10pm.
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        If a student is being dropped off or collected by a parent, guardian or
        trusted adult, we ask that you let us know the name of that person in
        advance, and that the named adult brings photographic ID with them.
        <br></br>
        <br></br>
        If you need to arrive/ depart outside of these times, please contact us
        at info@investin.org to let us know.
      </p>
    );
  }

  if (AirportCombination === "Airport_Arrival_and_Departure") {
    str_intoText = (
      <p style={{ fontSize: "1.3em" }}>
        As part of your experience you have booked an airport transfer with us,
        and in order for us to confirm the arrangements with you we need some
        information from you. Our InvestIN Transfer Service is available for
        flights arriving at Heathrow Airport between 6am and 6pm on your
        experience’s Check-In Day ({str_AccomStartDate}). If you are arriving
        outside of these hours please email info@investin.org. Please note we
        are unable to work with airline unaccompanied minor programmes for
        flights arriving outside of these times.
        <br></br>
        <br></br>
        Our InvestIN Transfer Service will be operating for flights departing
        between 9am and 6pm from Heathrow on their Check Out Day (
        {str_AccomEndDate}). For any flights departing later than 6pm, you can
        still use the transfer service but please do be aware that your student
        may need to spend an extended period of time at the airport waiting for
        their flight. If you are departing outside of these hours please contact
        info@investin.org.
        <br></br>
        For full information on how InvestIN’s airports transfers work please
        click{" "}
        <a
          href="https://docsend.com/view/qficjzrjx6rw5rwu"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </p>
    );
  }

  if (AirportCombination === "Airport_Arrival_Only") {
    str_intoText = (
      <p style={{ fontSize: "1.3em" }}>
        As part of your experience you have booked an airport transfer with us,
        and in order for us to confirm the arrangements with you we need some
        information from you. Our InvestIN Transfer Service is available for
        flights arriving at Heathrow Airport between 6am and 6pm on your
        experience’s Check-In Day ({str_AccomStartDate}). If you are arriving
        outside of these hours please email info@investin.org. Please note we
        are unable to work with airline unaccompanied minor programmes for
        flights arriving outside of these times.
        <br></br>
        For full information on how InvestIN’s airports transfers work please
        click{" "}
        <a
          href="https://docsend.com/view/qficjzrjx6rw5rwu"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .<br></br>
        <br></br>
        <br></br>
        <br></br>
        On the students' final day in the accommodation ({str_AccomEndDate}),
        they will need to check out of their rooms by 10am. They should leave by
        1pm.
        <br></br>
        Alternatively students can depart the evening of their final programme
        day ({str_EndDate}) 5pm and 10pm.
        <br></br>
        <br></br>
        If a student is being dropped off or collected by a parent, guardian or
        trusted adult, we ask that you let us know the name of that person in
        advance, and that the named adult brings photographic ID with them.
        <br></br>
        If you need to arrive/ depart outside of these times, please contact us
        at info@investin.org to let us know.
      </p>
    );
  }

  if (AirportCombination === "Airport_Departure_Only") {
    str_intoText = (
      <p style={{ fontSize: "1.3em" }}>
        Residential students should arrive at the accommodation between 12pm and
        5pm on check-in day ({str_AccomStartDate}). We will run an informal
        activity programme during this time. There will be a formal induction
        session at 6pm.
        <br></br>
        Alternatively students can arrive at the accomodation between 8am and
        10am on the first day of the programme ({str_StartDate}).
        <br></br>
        <br></br>
        On the students' final day in the accommodation ({str_AccomEndDate}),
        they will need to check out of their rooms by 10am. They should leave by
        1pm.
        <br></br>
        Alternatively students can depart the evening of their final programme
        day ({str_EndDate}) 5pm and 10pm.
        <br></br>
        <br></br>
        <br></br>
        As part of your experience you have booked an airport transfer with us,
        and in order for us to confirm the arrangements with you we need some
        information from you. Our InvestIN Transfer Service will be operating
        for flights departing between 9am and 6pm from Heathrow on their Check
        Out Day ({str_AccomEndDate}). For any flights departing later than 6pm,
        you can still use the transfer service but please do be aware that your
        student may need to spend an extended period of time at the airport
        waiting for their flight. If you are departing outside of these hours
        please contact info@investin.org.
        <br></br>
        For full information on how InvestIN’s airports transfers work please
        click{" "}
        <a
          href="https://docsend.com/view/qficjzrjx6rw5rwu"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
      </p>
    );
  }

  //-----------------------------------Check if times are bad
  let checkTimesBad = false;

  //Check override
  if (formInfo.Allow_All_Times !== "Yes") {
    //Check Arrival Dates First
    if (
      formInfo.Arrival_General_Date === "18th August 2025" ||
      formInfo.Arrival_General_Date === "28th July 2025" ||
      formInfo.Arrival_General_Date === "7th July 2025"
    ) {
      if (
        formInfo.Arrival_General_Arrival_Time < "08:00" ||
        formInfo.Arrival_General_Arrival_Time > "10:00"
      ) {
        checkTimesBad = true;
      }
    } else {
      if (AirportCombination === "No_Airport_Transfers") {
        if (
          formInfo.Arrival_General_Arrival_Time < "12:00" ||
          formInfo.Arrival_General_Arrival_Time > "17:00"
        ) {
          checkTimesBad = true;
        }
      } else if (AirportCombination === "Airport_Arrival_Only") {
        if (
          formInfo.Arrival_Airport_Arrival_Time < "06:00" ||
          formInfo.Arrival_Airport_Arrival_Time > "18:00"
        ) {
          checkTimesBad = true;
        }
      } else if (AirportCombination === "Airport_Departure_Only") {
        if (
          formInfo.Arrival_General_Arrival_Time < "12:00" ||
          formInfo.Arrival_General_Arrival_Time > "17:00"
        ) {
          checkTimesBad = true;
        }
      } else if (AirportCombination === "Airport_Arrival_and_Departure") {
        if (
          formInfo.Arrival_Airport_Arrival_Time < "06:00" ||
          formInfo.Arrival_Airport_Arrival_Time > "18:00"
        ) {
          checkTimesBad = true;
        }
      }
    }

    //Check Departure Dates Next

    if (
      formInfo.Departure_General_Date === "22nd August 2025" ||
      formInfo.Departure_General_Date === "29th August 2025" ||
      formInfo.Departure_General_Date === "1st August 2025" ||
      formInfo.Departure_General_Date === "8th August 2025" ||
      formInfo.Departure_General_Date === "11th July 2025" ||
      formInfo.Departure_General_Date === "18th July 2025"
    ) {
      if (
        formInfo.Departure_General_Departure_Time < "17:00" ||
        formInfo.Departure_General_Departure_Time > "22:00"
      ) {
        checkTimesBad = true;
      }
    } else {
      if (AirportCombination === "No_Airport_Transfers") {
        if (
          formInfo.Departure_General_Departure_Time < "06:00" ||
          formInfo.Departure_General_Departure_Time > "13:00"
        ) {
          checkTimesBad = true;
        }
      } else if (AirportCombination === "Airport_Arrival_Only") {
        if (
          formInfo.Departure_General_Departure_Time < "06:00" ||
          formInfo.Departure_General_Departure_Time > "13:00"
        ) {
          checkTimesBad = true;
        }
      } else if (AirportCombination === "Airport_Departure_Only") {
        if (
          formInfo.Departure_Airport_Departure_Time < "09:00" ||
          formInfo.Departure_Airport_Departure_Time > "18:00"
        ) {
          checkTimesBad = true;
        }
      } else if (AirportCombination === "Airport_Arrival_and_Departure") {
        if (
          formInfo.Departure_Airport_Departure_Time < "09:00" ||
          formInfo.Departure_Airport_Departure_Time > "18:00"
        ) {
          checkTimesBad = true;
        }
      }
    }
  }

  //-----------------------------------End Check if times are bad

  if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions &&
    (Object.keys(StudentData).length === 0 ||
      Object.keys(obj_EC).length === 0 ||
      Object.keys(obj_assignedEC).length === 0)
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Checking Access Permissions...</h1>
      </div>
    );
  } else if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Access Denied</h1>
      </div>
    );
  } else if (Object.keys(BasicInfo).length === 0) {
    return (
      <div className="view-basic-info-container">
        <h1>Loading...</h1>
      </div>
    );
  } else {
    return (
      <div className="view-basic-info-container">
        <h1>
          Summer Arrival & Departure Information, {str_AccomStartDate},{" "}
          {str_AccomEndDate}
          <br></br>
          <div
            style={{
              textAlign: "center",
              fontFamily: "Arial, sans-serif",
              marginTop: "50px",
            }}
          >
            <h1 style={{ color: "#333", fontSize: "1em" }}>
              Programme Information:
            </h1>
            <h2 style={{ color: "#555", fontSize: "0.5em" }}>
              Programme Title: {BasicInfo.ProgrammeTitle}
              <br></br>
              Programme Varient: {BasicInfo.ProgrammeVarient}
              <br></br>
              Programme Start Date: {str_StartDate}
              <br></br>
              Programme End Date: {str_EndDate}
              {BasicInfo.ProgrammeVarient?.toLowerCase().includes("accom") ? (
                <>
                  <br></br>
                  Accommodation Check-in Date: {str_AccomStartDate}
                  <br></br>
                  Accommodation Check-out Date: {str_AccomEndDate}
                </>
              ) : (
                <></>
              )}
            </h2>
          </div>
        </h1>
        {str_intoText}
        <br></br>
        {formInfo.Allow_All_Times === "Yes" ? (
          <form className="view-basic-info-form">
            <table>
              <thead>
                <tr>
                  <th>
                    A member of the InvestIN team has enabled this account to
                    select times outside of the usual hours
                  </th>
                </tr>
              </thead>
            </table>
          </form>
        ) : (
          <></>
        )}
        <br></br>
        {formInfo &&
        formInfo.Progress &&
        (formInfo.Progress === "Complete" ||
          formInfo.Progress === "Awaiting_Review") ? (
          <strong>
            If you need to make further changes, please contact InvestIN at
            info@investin.org or speak to your known contact
          </strong>
        ) : (
          ""
        )}{" "}
        <form className="view-basic-info-form">
          {DateQuestions.map((question) => {
            if (
              (AirportCombination === "Airport_Arrival_Only" &&
                (question.Type === "Arrival_Airport" ||
                  question.Type === "Departure_General")) ||
              (AirportCombination === "Airport_Departure_Only" &&
                (question.Type === "Arrival_General" ||
                  question.Type === "Departure_Airport")) ||
              (AirportCombination === "Airport_Arrival_and_Departure" &&
                (question.Type === "Departure_Airport" ||
                  question.Type === "Arrival_Airport")) ||
              (AirportCombination === "No_Airport_Transfers" &&
                (question.Type === "Arrival_General" ||
                  question.Type === "Departure_General"))
            ) {
              return (
                <>
                  <h2>{question.Title}</h2>
                  <>
                    {window.innerWidth >= 800 ? (
                      <></>
                    ) : (
                      <div style={{ fontSize: "1.2rem", color: "black" }}>
                        <i>{question.Label}:</i>
                      </div>
                    )}
                    <TextField
                      label={window.innerWidth >= 800 ? question.Label : ""}
                      name={question.Name}
                      value={formInfo[question.Name] || ""}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                      select
                      InputProps={inputProps}
                      InputLabelProps={inputLabelProps}
                      SelectProps={{
                        MenuProps: {
                          disableScrollLock: true, // Prevents scrolling when dropdown is opened
                        },
                      }}
                    >
                      <MenuItem value="">-----</MenuItem>
                      {question.Options.map((value) => (
                        <MenuItem key={value} value={value}>
                          {value}
                        </MenuItem>
                      ))}
                    </TextField>
                  </>
                  {Array.from(
                    { length: question.Length },
                    (_, i) => i + question.Start
                  ).map((i) => (
                    <>
                      <DisplayTextField
                        formInfo={formInfo}
                        handleChange={handleChange}
                        Object={Arr_SummerArrivalDeparture[i]}
                      />
                    </>
                  ))}
                </>
              );
            }
          })}
          <h2>Anything else we need to know</h2>
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={
              Arr_SummerArrivalDeparture[Arr_SummerArrivalDeparture.length - 1]
            }
          />

          {checkTimesBad ? (
            <h3>
              Please check the times you submitted are within our allowed times.
              If you need to arrive/ depart outside of these times, please
              contact us at info@investin.org to let us know.
            </h3>
          ) : (
            <></>
          )}

          <h3>
            Once this page is completed and you have completed every question,
            please click "Submit" to complete the page and send it for review by
            InvestIN. Otherwise, click "Save" if you are not ready to complete
            the page and wish to return later to make changes
          </h3>
          <div className="view-basic-info-buttons">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveProgress}
              disabled={
                status ||
                (formInfo &&
                  formInfo.Progress &&
                  (formInfo.Progress === "Complete" ||
                    formInfo.Progress === "Awaiting_Review")) ||
                Object.keys(formInfo).length === 0
              }
            >
              Save Progress
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
              disabled={
                !isFormComplete ||
                status ||
                (formInfo &&
                  formInfo.Progress &&
                  (formInfo.Progress === "Complete" ||
                    formInfo.Progress === "Awaiting_Review")) ||
                Object.keys(formInfo).length === 0 ||
                checkTimesBad
              }
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default ArrivalDeparture;
